import { render, staticRenderFns } from "./AvaliacaoRespostas.vue?vue&type=template&id=01027e20&scoped=true"
import script from "./AvaliacaoRespostas.vue?vue&type=script&lang=js"
export * from "./AvaliacaoRespostas.vue?vue&type=script&lang=js"
import style0 from "./AvaliacaoRespostas.vue?vue&type=style&index=0&id=01027e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01027e20",
  null
  
)

export default component.exports